import type { FoldedItem } from "./shared";

/** What everything else holds, over the chart while it is hovered. */
export function FoldedBreakdown({ title, items }: { title: string; items: readonly FoldedItem[] }) {
  return (
    <div className="pointer-events-none absolute top-8 right-0 z-10 w-72 max-w-full rounded-xl bg-background px-3 py-2 text-xs shadow-[0_4px_12px_rgb(0_0_0/0.06),0_16px_32px_-12px_rgb(0_0_0/0.2)] ring-1 ring-foreground/10">
      <p className="text-muted-foreground">{title}</p>
      <ul className="mt-1 space-y-0.5">
        {items.map(item => (
          <li key={item.key} className="flex justify-between gap-4">
            <span className="min-w-0 truncate">{item.label}</span>
            <span className="shrink-0 tabular-nums">{item.value}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
